module.exports = __webpack_public_path__ + "img/gift4-01-c09-y1.2a996be8.png";